// =============================================================================
// GeoNames (proxy backend): país → división(es) → ciudad, con centroide.
// La profundidad de niveles la decide el país (ES para en provincia nv2,
// Andorra en parroquia nv1), no la asumimos.
// =============================================================================
import { apiClient } from './http';

export interface GeoCountry { code: string; name: string }
export interface GeoDivision { code: string; name: string; admin1_code?: string; admin2_code?: string }
export interface GeoPlace {
  name: string;
  admin1_code?: string;
  admin2_code?: string;
  coordinates?: { lat: number; lng: number };
}

export async function geoCountries(): Promise<GeoCountry[]> {
  const res = await apiClient.get<{ countries: GeoCountry[] }>('/geo/countries', { params: { lang: 'es' } });
  return res.data.countries ?? [];
}

export async function geoDivisions(country: string, level: number): Promise<GeoDivision[]> {
  const res = await apiClient.get<{ divisions: GeoDivision[] }>(
    `/geo/countries/${country}/divisions`,
    { params: { level, lang: 'es' } }
  );
  return res.data.divisions ?? [];
}

export async function geoPlaces(
  country: string,
  opts: { admin1_code?: string; admin2_code?: string; q?: string } = {}
): Promise<GeoPlace[]> {
  const res = await apiClient.get<{ places: GeoPlace[] }>(
    `/geo/countries/${country}/places`,
    { params: { ...opts, lang: 'es', limit: 500 } }
  );
  return res.data.places ?? [];
}

export interface AddressHit {
  label: string;
  latitude: number;
  longitude: number;
  road?: string | null;
  house_number?: string | null;
  city?: string | null;
  postcode?: string | null;
  province?: string | null;
  country_code?: string | null;
}

/** Autocompletado de dirección de calle (Nominatim/OSM) con punto preciso. */
export async function geoAddress(q: string, country?: string): Promise<AddressHit[]> {
  const res = await apiClient.get<AddressHit[]>('/geo/address', { params: { q, country } });
  return res.data ?? [];
}
